
// This file is generated.
// Do not edit it!  Your work will be overwritten.
//
// Instead, please look at ./tools/set_version.js

"use strict";

module.exports = "1.2.0";
